"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconReadHome1 = /*#__PURE__*/
function (_Icon) {
  _inherits(IconReadHome1, _Icon);
  function IconReadHome1(props) {
    var _this;
    _classCallCheck(this, IconReadHome1);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconReadHome1).call(this, props));
    _this.name = 'IconReadHome1';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "read-home-1_svg__group0"
    }, _react2.default.createElement("path", {
      className: "read-home-1_svg__path0",
      d: "M9.75 20.492a.498.498 0 01-.427-.239c-.016-.026-1.87-2.817-7.655-3.081A1.493 1.493 0 01.25 15.669V3.016a1.498 1.498 0 01.505-1.118 1.5 1.5 0 011.089-.381c4.747.248 7.017 2.042 7.906 3.011.889-.969 3.159-2.763 7.908-3.011l.081-.002a1.51 1.51 0 011.51 1.502v7.471a.5.5 0 01-1 0l-.001-7.509a.511.511 0 00-.51-.463l-.028.001c-3.021.157-4.92.999-5.981 1.677-.858.548-1.312 1.075-1.481 1.296v13.208c.204-.178.421-.342.648-.49a.501.501 0 01.546.838 4.772 4.772 0 00-1.262 1.2.497.497 0 01-.43.246zM1.758 2.515a.505.505 0 00-.508.48l-.001.031v12.647a.493.493 0 00.468.5c4.097.187 6.38 1.525 7.532 2.532V5.49c-.37-.475-2.371-2.709-7.46-2.974l-.031-.001z"
    }), _react2.default.createElement("path", {
      className: "read-home-1_svg__path1",
      d: "M23.249 16.989a.499.499 0 01-.316-.113l-4.867-3.982a.504.504 0 00-.634 0l-4.867 3.982a.503.503 0 01-.703-.07.5.5 0 01.07-.703L16.8 12.12a1.505 1.505 0 011.898-.001l4.867 3.982a.501.501 0 01-.316.888z"
    }), _react2.default.createElement("path", {
      className: "read-home-1_svg__path2",
      d: "M14.25 22.489a1 1 0 01-1-1v-4a.5.5 0 011 0v4h2v-2a1 1 0 011-1h1a1 1 0 011 1v2h2v-4a.5.5 0 011 0v4a1 1 0 01-1 1h-7zm4-1v-2h-1v2h1z"
    })));
    return _this;
  }
  return IconReadHome1;
}(_Icon3.default);
exports.default = IconReadHome1;